import { createFileRoute } from '@tanstack/react-router'
import { VisitEditor } from './-VisitEditor'

export const Route = createFileRoute('/crm/visitors/$id')({
  component: VisitDetailPage,
})

function VisitDetailPage() {
  const { id } = Route.useParams()
  return <VisitEditor id={id} />
}
